var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-user-item-container"},[(_vm.item.FLAG_k_off == 0)?_c('div',[_c('b',[_vm._v(_vm._s(_vm.item.k))]),_vm._v(" руб. ")]):_c('div',[_vm._v("отключен")])])}
var staticRenderFns = []

export { render, staticRenderFns }